import TaggedText from "components/TaggedText";


export function ErrorMessage(
  {
    errorMessage,
    closeModalCallback = () => {}
  }: { errorMessage: string | JSX.Element | undefined, closeModalCallback?: () => void }
) {
  if (typeof errorMessage === "string") {
    return (
      <div className="text-red-500 dark:text-error-500">
        <span className="font-bold">Error:</span>{ " " }<TaggedText message={ errorMessage }
                                                                    tagCallbacks={ { "contact_support": closeModalCallback } }
                                                                    linkStyle="transition-colors text-red-500 dark:text-error-500 hover:text-red-800 dark:hover:text-error-800"
      />
      </div>
    );
  } else if (errorMessage) {
    return (
      <div className="text-red-500 dark:text-error-500">
        <span className="font-bold">Error:</span>{ " " }{ errorMessage }
      </div>
    )
  } else {
    return <></>;
  }
}
